import React from 'react';
import { connect } from "react-redux";
import { Card } from 'react-bootstrap';
import { isElasticLoad } from '../../../helpers/common';
import { NumberLoader } from '../../widgets/Loader';

const NumberBox = (props) => {
    const { item, settings: { weightShortName } } = props;
    return <Card className='widget-card' style={{ backgroundColor: item.primaryColor }}>
        <div className="value">{item.isRequesting ? <NumberLoader /> : item.value}</div>
        <div className="details d-flex">
            <div className="label">{item.name}</div>
            {!isElasticLoad() && item.id === 3 && !item.isRequesting && <div className="subValue">
                {item.subValue}<span className="unit">{weightShortName}</span>
            </div>}
        </div>
    </Card>
};

const mapStateToProps = state => ({
    settings: {
        weightShortName: state.user.settings.weightShortName
    }
});

export default connect(mapStateToProps)(NumberBox);